import { getColorRgba } from '../colors';
import { MissionSummaryMission } from '@edwin-group/cj-graphql';
import { ChartData } from 'chart.js';

export const parseMissionSummary = (reportData: MissionSummaryMission[], missionSelected: string | null) => {
  if (!missionSelected) {
    return {
      labels: [],
      datasets: [],
    };
  }

  const missionNames = Array.from(new Set(reportData?.map((item) => item.roleModel)));
  const cohortNames = Array.from(
    new Set(
      reportData
        ?.flatMap((item) => item.rows)
        ?.map((row) => row?.cohortName)
        .filter(Boolean) || [],
    ),
  );
  const datasets = cohortNames?.map((cohortName, index) => {
    const color1 = getColorRgba(index, 0.3);
    const color2 = getColorRgba(index, 1);

    //every value in this array is one mission
    const assessments = reportData?.map((data) => {
      return (
        data.rows?.find((row) => row?.cohortName === cohortName && row?.roleModel === missionSelected) || {
          preAssessment: 0,
          postAssessment: 0,
        }
      );
    });

    return [
      {
        // Pre
        // Every pre assessment
        label: `${cohortName} - Pre`,
        data: assessments?.map((assess) => assess.preAssessment),
        backgroundColor: color1,
      },
      {
        //Post
        // Every post assessment
        label: `${cohortName} - Post`,
        data: assessments?.map((assess) => assess.postAssessment),
        backgroundColor: color2,
      },
    ];
  });

  const radarData = {
    labels: missionNames,
    datasets: datasets.flatMap((dataset) => dataset),
  } as ChartData<'bar'>;

  return radarData;
};
